import styled from 'styled-components'
import { rwd } from '@stokr/components-library'

export const RelatedArticlesSection = styled.div`
  margin-top: 4rem;
  padding: 0 2rem;
  margin-bottom: 4rem;

  h2 {
    margin-bottom: 2rem;
    //text-align: center;
  }

  ${rwd.Medium`
    margin-top: 6rem;
    padding: 0 4rem;
  `}
`
